import React from 'react';
import { Box, keyframes } from '@mui/material';

interface StreamingTextProps {
  text: string;
  isStreaming: boolean;
}

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

/**
 * 流式文本渲染，带闪烁光标。
 */
const StreamingText: React.FC<StreamingTextProps> = ({ text: _text, isStreaming }) => {
  return (
    <Box component="span" sx={{ display: 'inline' }}>
      {isStreaming && (
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: '2px',
            height: '1em',
            bgcolor: 'primary.main',
            ml: 0.3,
            verticalAlign: 'middle',
            animation: `${blink} 1s step-end infinite`,
          }}
        />
      )}
    </Box>
  );
};

export default StreamingText;
